export const increaseCreditLink = (region, isReapplication) => {
  let link = `/${region}/apply/increase_credit`;
  if (isReapplication) {
    link += '?re-apply=true';
  }
  return link;
};
